module.exports = __webpack_public_path__ + "img/discord.659da351.svg";